import React from "react";

export default function PageHeader({
  actions = null,
  className = "",
  icon,
  iconAlt = "",
  subtitle,
  title,
}) {
  return (
    <div className={`new-page-header ${className}`.trim()}>
      <div className="new-page-header__main">
        {icon ? (
          <span className="new-page-header__icon" aria-hidden={iconAlt ? undefined : "true"}>
            {typeof icon === "string" ? <img src={icon} alt={iconAlt} /> : icon}
          </span>
        ) : null}

        <div className="new-page-header__copy">
          <h1>{title}</h1>
          {subtitle ? <p>{subtitle}</p> : null}
        </div>
      </div>

      {actions ? <div className="new-page-header__actions">{actions}</div> : null}
    </div>
  );
}
